import { Divider } from 'antd';
import { Name } from '../location/info/name/Name';
import { Description } from '../location/info/description/Description';
import { StoreCode } from '../location/info/storeCode/StoreCode';
import { Coordinates } from '../location/info/seo/Coordinates';
import { PlaceId } from '../location/info/seo/PlaceId';

const InfoTab = ({ location, locationsIds}: any) => {
    return (
        < >
            <Name titleStatus={location.title!} locationsIds={locationsIds} shield={location.shieldFields}/>
            <Divider orientation="left" style={{ margin: "15px" }} plain></Divider>
            <Description descriptionStatus={location.description!} locationsIds={locationsIds} />
            <Divider orientation="left" style={{ margin: "15px" }} plain></Divider>
            <StoreCode storeCode={location.storeCode!} locationsIds={locationsIds} />
            <Divider orientation="left" style={{ margin: "15px" }} plain></Divider>
            <PlaceId placeId={location.metadata.placeId} />
            <Divider orientation="left" style={{ margin: "15px" }} plain></Divider>
            <Coordinates lat={location.latitude} lng={location.longitude} />
            
        </>
    );
};

export default InfoTab;